/* eslint-disable */
// This code is autogenerated using @harnessio/oats-cli.
// Please do not modify this code directly.
import type { SpeakerResetRequest } from '../schemas/SpeakerResetRequest';
import { fetcher, FetcherOptions } from './fetcher';

export type UserSpeakerResetCreateRequestBody = SpeakerResetRequest;

export type UserSpeakerResetCreateOkResponse = unknown;

export type UserSpeakerResetCreateErrorResponse = unknown;

export interface UserSpeakerResetCreateProps
  extends Omit<
    FetcherOptions<unknown, UserSpeakerResetCreateRequestBody>,
    'url'
  > {
  body: UserSpeakerResetCreateRequestBody;
}

export function userSpeakerResetCreate(
  props: UserSpeakerResetCreateProps
): Promise<UserSpeakerResetCreateOkResponse> {
  return fetcher<
    UserSpeakerResetCreateOkResponse,
    unknown,
    UserSpeakerResetCreateRequestBody
  >({
    url: `/user/speaker/reset/`,
    method: 'POST',
    ...props
  });
}
